import YouTubePlayer from "youtube-player";

document.addEventListener("DOMContentLoaded", function () {
    const play_button = document.getElementById("play_button");
    const player_element = document.getElementById("header_player");
    const header_element = document.getElementById("content__header");

    if (play_button && player_element) {
        let player = YouTubePlayer("header_player");

        play_button.addEventListener("click", function () {
            player.loadVideoById(play_button.dataset.ytid);
            header_element.classList.add("playing");
            player.playVideo();
        });
    }
});
